import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";

import useDelayForm from "./useDelayForm";
import DelayForm from "./DelayForm";

export default DelayNodeConfig;

function DelayNodeConfig(props) {
  const { node, closePanel, validationErrors, onSave } = props;

  const { formState, validate, errors, updateFormState } = useDelayForm(
    node.data,
    validationErrors,
  );

  const handleSave = () => {
    if (!validate()) return;

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Delay</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <DelayForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end gap-x-2 items-center">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
